import { render, staticRenderFns } from "./CRMHome.vue?vue&type=template&id=22d7bff0&scoped=true&"
import script from "./CRMHome.vue?vue&type=script&lang=js&"
export * from "./CRMHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7bff0",
  null
  
)

export default component.exports